import uploadsarticlesbestDuiLawyerInSacramentoCaimagesacramentoDuiLawyerOfficeJpg from "$lib/data/generated/uploads/articles/best-dui-lawyer-in-sacramento-ca/image/sacramento-dui-lawyer-office.jpg";

export const uploads = {
  "uploads/articles/best-dui-lawyer-in-sacramento-ca/image/sacramento-dui-lawyer-office.jpg": uploadsarticlesbestDuiLawyerInSacramentoCaimagesacramentoDuiLawyerOfficeJpg
};